module.exports = __webpack_public_path__ + "img/42_8.ce8969b0.png";